import {
  getAccessTokenRefreshDelay,
  performRefresh,
} from 'modules/user/silentRefresh';
import { getLocalAccessToken } from 'modules/user/userCookies';

interface Props {
  sendAuth: () => void;
  connect: () => void;
  disconnect: () => void;
  waitForSocketOpen: () => Promise<void>;
}

export const handleAccessTokenRefresh = async ({
  sendAuth,
  waitForSocketOpen,
  connect,
  disconnect,
}: Props) => {
  const token = getLocalAccessToken();
  disconnect?.();
  connect?.();

  const auth = () =>
    setTimeout(() => {
      sendAuth();
    }, 100);

  if (token) {
    const refreshTime = getAccessTokenRefreshDelay(token, 5);

    if (refreshTime <= 0) {
      try {
        await waitForSocketOpen();
        await performRefresh({
          isNotSilentRefresh: true,
          onTokenRefreshed: auth,
        });
      } catch (err) {
        console.error('Silent refresh failed at startup', err);
      }
    } else {
      await waitForSocketOpen();
      auth();
    }
  }
};
